import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUserAuth } from "../../context/UserAuthContext";
import Modal from "react-bootstrap/Modal";
import GenrateInvoice from "./GenrateInvoice";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";

const InoiceList = () => {
  const { user, token } = useUserAuth();
  const merchant_id = user.uid;

  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [data, setData] = useState([]);
  const [merchant, setMerchant] = useState([]);
  console.log(merchant);
  const [searchQuery, setSearchQuery] = useState("");
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/invoice-basics/${merchant_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
      );
      setMerchant(res.data.data);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  useEffect(() => {
    if (!merchant_id) return;
    const getBookVenueList = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/invoice/user/${merchant_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
        setData(res.data.data);
      } catch (error) {
        console.log(`Error ${error} `);
      }
    };
    getBookVenueList();
  }, [merchant_id, token]);

  const deleteHandler = async (id) => {
    const choice = window.confirm("Are you sure want to delete");
    if (choice) {
      try {
        const res = await axios.delete(`${base_url}/api/v1/invoice/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        const updatedData = data.filter((curItem) => curItem.id !== id);
        setData(updatedData);
        toast.success("Invoice deleted successfully.");
      } catch (error) {
        console.log(`Error ${error} `);
      }
    } else {
      return;
    }
  };
  const [myPdf, setMyPdf] = useState();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    console.log("Closing modal...");
    setShow(false);
    setMyPdf();
  };

  const pdfHandler = (cur) => {
    console.log("Handling PDF click...", cur);
    handleShow();
    setMyPdf(cur);
  };
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Download Pdf</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <GenrateInvoice pdfData={myPdf} merchantInfo={merchant} />
          </Modal.Body>
        </Modal>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#085f9a" }}
              >
                <div>
                  <input
                    type="text"
                    placeholder="Search Invoice List..."
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                  />
                </div>

                <Link
                  to="/dashboard/invoice-create"
                  className="btn text-dark productbutton"
                  style={{ backgroundColor: "#fff" }}
                >
                  <div>Create Invoice List</div>
                </Link>
              </div>
              <div className="card-body">
                <h2>Invoice List</h2>
                <div className="table-responsive">
                  <table
                    className="table  table-bordered  shadow-sm mt-3"
                    cellPadding={5}
                  >
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>Customer Name</th>
                        <th>Billing Address</th>
                        <th>Shipping Address</th>
                        <th>Total Amount</th>
                        <th>CreatedAt</th>
                        <th>Download PDF</th>
                        {/* <th>Delete</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {data
                        ?.filter((curEle) =>
                          curEle.customerinfo.customerName
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        )
                        .map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.customerinfo.customerName}</td>
                              <td>{item.customerinfo.billToAddress}</td>
                              <td>{item.customerinfo.shipToAddress}</td>
                              <td>&#8377; {item.totalamount}</td>
                              <td>
                                {dayjs(item.createdAt).format("DD MMM, YYYY")}
                              </td>
                              <td
                                className="text-danger text-center"
                                style={{ cursor: "pointer" }}
                              >
                                <button
                                  className="btn btn-success btn-sm text-white"
                                  onClick={() => pdfHandler(item)}
                                >
                                  Download
                                </button>
                              </td>
                              {/* <td>
                                <MdDelete
                                  size={24}
                                  color="red"
                                  onClick={() => deleteHandler(item.id)}
                                />
                              </td> */}
                            </tr>
                          );
                        })}
                      {data.length < 1 && (
                        <tr>
                          <td colSpan={8}>No record found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InoiceList;
